export default __webpack_public_path__ + "static/media/shopping-cart.df85bfec.svg";